<div [hidden]="loading" class="router-output">
  <app-header *ngIf="showExtraComponentsValue()"></app-header>
  <app-sidemenu *ngIf="showExtraComponentsValue()"></app-sidemenu>
  <router-outlet></router-outlet>
  <app-footer *ngIf="showExtraComponentsValue()"></app-footer>
</div>
<div [hidden]="!loading" class="loader">
  <!-- <h2>Loading...</h2> -->
</div>
<script type="text/javascript" src="../assets/js/demo.js"></script>
